import http from '../http'

/**
 * 律师首页相关接口
 */
const homeApi = {
  /**
   * 获取套餐列表
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getComboList(params) {
    return http.get('/system/combo/list', params)
  },


  /**
   * 获取套餐详情
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getComboDetail(params) {
    return http.get('/system/combo/getById', params)
  },

  /**
   * 保存总价
   * @param {Object} params - 查询参数 {comboId, totalPrice}
   * @returns {Promise}
   */
  saveTotalPrice(params) {
    return http.get('/system/userCoupon/getUserCanUse', params)
  },

  /**
   * 生成订单
   * @param {Object} params - 查询参数 {comboId, totalPrice}
   * @returns {Promise}
   */
  createOrder(data) {
    return http.post('/system/order/doAdd', data)
  },

  
  /**
   * 发起支付
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  payOrder(params) {
    return http.get('/system/order/payOrderWeb', params)
  },


 /**
   * 发起文书支付
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  payOrderForWs(params) {
  return http.get('/system/orderBook/payOrderWeb', params)
},


  /**
   * 查询支付状态
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getPaymentStatus(params) {
    return http.get('/system/order/queryStatus', params)
  },

  
  /**
   * 查询支付状态文书
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getPaymentStatusForWs(params) {
    return http.get('/system/orderBook/queryStatus', params)
  },


  /**
   * 获取专项服务列表
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getCustomServiceList(params) {
    return http.get('/system/combo/getForDz', params)
  },

  /**
   * 获取法律文书列表
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getLegalInstrumentList(params) {
    return http.get('/system/bookCategory/list', params)
  },

    
  /**
   * 根据文大类id获取法律文书列表
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getLegalInstrumentListByCategoryId(params) {
    return http.get('/system/book/list', params)
  },

  /**
   * 购买法律文书
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */ 
  buyLegalInstrument(data) {
    return http.post('/system/orderBook/doAdd', data)
  },

  /**
   * 获取法律文书列表 for web
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getLegalInstrumentListForWeb(params) {
    return http.get('/system/book/forWeb', params)
  },

  /**
   * 获取法律知识列表 for web
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */ 
  getLegalKnowledgeListForWeb(params) {
    return http.get('/system/knowledge/forWeb', params)
  },

  /**
   * 获取法律知识详情 for web
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */ 
  getLegalKnowledgeDetailForWeb(params) {
    return http.get('/system/knowledge/getById', params)
  },

  /**
   * 获取视频课程列表 for web
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */  
  getVideoCoursesListForWeb(params) {
    return http.get('/system/video/forWeb', params)
  },
  

  /**
   * 获取协议信息
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getAgreementList(id) {
    return http.get(`/article/${id}`)
  },

  /**
   * 获取底部导航栏
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */
  getBottomNavList(id) {
    return http.get(`/system/knowledge/suiji`)
  },
  // 获取可使用优惠券列表
  getMyUseCoupon(params) {
    return http.get('/system/userCoupon/getUserCanUseList', params)
  },

   /**
   * 新增企业
   * @param {Object} params - 查询参数 {comboType }
   * @returns {Promise}
   */ 
   addCompany(data) {
    return http.post('/wxuser/wxuser/userAddComapany', data)
  },

  // 获取首页律师
  getLsListApi(params) {
    return http.get('/system/lsSettting/listFroWeb', params)
  },
}

export default homeApi 